import BaseService from '../baseService'

export class TransactionService extends BaseService {
  fetchTransactions(loanId) {
    return this.client.get(`ledger-entries?loanId=${loanId}`).json()
  }
}
